<template>
  <div class="p_f d_f ali_c sh">
    <img
      src="../assets/img/th_back.png"
      alt=""
      class="cur_p"
      @click="revert"
    >
    <div class="flex_1 d_f ali_c h_input">
      <img
        src="../assets/img/search_black.png"
        alt=""
      >
      <input
        v-model="searchKey"
        type="text"
        placeholder="搜索景点/美食/酒店/商圈等"
      >
    </div>
    <span
      class="cur_p"
      @click="search"
    >搜索</span>
  </div>
</template>

<script>
  export default {
    name: "SearchHead",
    props:{
      searchKey:{//标题
        type:String,
        default:''
      },
      isRload:{//标题
        type:Boolean,
        default:false
      },
    },
    data() {
      return {
        arr:[],
        isDestroyed:false,
      }
    },
    beforeUnmount(){
      this.isDestroyed = true;
      console.log(this.isDestroyed)
    },
    created(){
      let arr = localStorage.getItem('search') ? JSON.parse(localStorage.getItem('search')) : [];
      this.arr = JSON.parse(JSON.stringify(Array.from(new Set(arr))));
    },
    methods: {
      revert(){
        if (window.history.length <= 1) {
          this.backApp()
          return false
        } else {
          this.$router.go(-1)
        }
        //上面都没执行就说明卡在当前页不是最后一条， histroy记录数量大于1，又没有回退记录，只能返回首页，
        //如果上面都执行了 页面都跳走了，这个也就不用管了

        setTimeout(() => {
          console.log(this.isDestroyed)
          if(this && !this.isDestroyed){//isDestroyed 组件是否被销毁
            console.log('this.isDestroyed)')
            this.backApp()
          }
        },1000)
      },
      backApp(){
        // localStorage.clear()
        if(this.$global.modelState){
          window.android.exit();
        }else {
          this.$iosMethod(function(bridge) {
            bridge.callHandler('exit', null,function(data) {

            })
          })
        }
      },
      search(){
        if(this.searchKey){

          let arr = localStorage.getItem('search') ? JSON.parse(localStorage.getItem('search')) : [];
          this.arr = JSON.parse(JSON.stringify(Array.from(new Set(arr))));
          this.arr.push(this.searchKey);
          localStorage.setItem('search',JSON.stringify(this.arr))
        }
        this.$router.push('/searchList?searchKey='+this.searchKey);
        if(this.isRload){
          this.$emit('reGetInfo',this.searchKey)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .sh{
    height: 120px;
    padding: 0 25px;
    box-sizing: border-box;
    left: 0;
    top: 0;
    width: 100%;
    background-color: white;
    z-index: 999;
    >span{
      margin-left: 29px;
      font-size: 30px;
      font-weight: bold;
      color: #3E3E3E;
    }
    >img{
      width: 19px;
      height: 34px;
      margin-right: 30px;
    }
  }
  .h_input{
    background-color: rgba(255,255,255,0.2);
    box-sizing: border-box;
    input{
      font-weight: bold;
      color: #FFFFFF;
      border: none;
      outline: none;
      background-color: transparent;
      &::placeholder{
        font-weight: bold;
        color: #FFFFFF;
      }
    }
  }
  .h_input{
    height: 71px;
    border-radius: 35px;
    padding: 13px 23px;
    box-sizing: border-box;
    box-shadow: 0 0 2px 2px #D0D0D0;
    img{
      width: 44px;
      height: 46px;
    }
    input{
      width: calc(100% - 44px);
      box-sizing: border-box;
      padding-left: 70px;
      font-size: 28px;
      font-weight: bold;
      color: #333;
      border: none;
      outline: none;
      background-color: transparent;
      &::placeholder{
        font-size: 28px;
        font-weight: bold;
        color: #D0D0D0;
      }
    }
  }

</style>
